const sliderOptions = {
  items: [],
  active: [],
  move: true,
};
const sliderSection = {
  run: () => {
    sliderOptions.active = [];
    sliderOptions.active.push(jQuery('#slider-section .item').length - 1);
    jQuery('#slider-section .item').each(function (index) {
      sliderOptions.items.push(jQuery(this));
      if (jQuery.inArray(index, sliderOptions.active) == -1) {
        sliderOptions.active.push(index);
      }
    });

    sliderSection.render();
    sliderSection.jquery();
  },

  prev: () => {
    let last_item = sliderOptions.active[sliderOptions.active.length - 1];
    for (var i = sliderOptions.active.length - 1; i > 0; i--) {
      sliderOptions.active[i] = sliderOptions.active[i - 1];
    }
    sliderOptions.active[0] = last_item;
    sliderSection.render();
  },

  next: () => {
    let first_item = sliderOptions.active[0];
    for (var i = 0; i < sliderOptions.active.length - 1; i++) {
      sliderOptions.active[i] = sliderOptions.active[i + 1];
    }
    sliderOptions.active[sliderOptions.active.length - 1] = first_item;
    sliderSection.render();
  },

  render: () => {
    jQuery('#slider-section .item').removeClass('pre-first').removeClass('first').removeClass('second').removeClass('third').removeClass('suf-third');
    if (sliderOptions.active[0] != undefined) {
      sliderOptions.items[sliderOptions.active[0]].addClass('pre-first');
    }
    if (sliderOptions.active[1] != undefined) {
      sliderOptions.items[sliderOptions.active[1]].addClass('first');
    }
    if (sliderOptions.active[2] != undefined) {
      sliderOptions.items[sliderOptions.active[2]].addClass('second');
    }
    if (sliderOptions.active[3] != undefined) {
      sliderOptions.items[sliderOptions.active[3]].addClass('third');
    }
    if (sliderOptions.active[4] != undefined) {
      sliderOptions.items[sliderOptions.active[4]].addClass('suf-third');
    }
  },

  jquery: () => {

    jQuery(function () {
      var touch = {
        status: false,
        position: 0
      };
      jQuery('#slider-section').on("touchstart", function (event) {
        if (!touch.status) {
          touch.status = true;
          touch.position = event.touches[0].clientX;
        }
      });

      jQuery('#slider-section').on("touchmove", function (event) {
        if (touch.status) {
          // alert(touch.position + '-' + event.touches[0].clientX)
          if (touch.position < event.touches[0].clientX) {
            sliderSection.next();
          } else if (touch.position >= event.touches[0].clientX) {
            sliderSection.prev();
          }

          touch = {
            status: false,
            position: 0
          }
        }
      });
    });
  }
}